export const AMOUNT_MIN_VALUE = 3000;
export const SRAVNI_LOGO_URL = 'https://s91588.cdn.ngenix.net/shared/static/images/design-system/sravni-logo-sign.png';
